export const SKELETON_CONFIG = [100, 100, 60, 60];
export const SKELETON_ELEMENT_HEIGHT = 280;
